<script setup lang="ts">
import { inject, onMounted, ref } from "vue"

/**
 *
 *  Props and emits section
 *
 *
 */
 const { $bus } = useNuxtApp()


/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

 const initSetting = useDefaultSettingsStore()
const { settings } = storeToRefs(initSetting)
const coin = ref(settings.value.system_coin)
watch(settings, () => {
    coin.value = settings.value.system_coin
})

const {post}=useOFetchCustom('set-system-coin')

/**
 *
 *  Life cicle events
 *
 *
 */

onMounted(() => {
    
})

/**
 *
 *  Functions section
 *
 *
 */
 
const change = (value:any) => {
    post({coin: value},{
        onSuccess: () => {
            window.location.reload() 
            //  refreshNuxtData()
        }
    })
}
</script>
<template>
     <q-select
        v-model="coin"
        borderless
        :options-dark="false"
        options-dense
        :options="settings.coins_availables"
        @update:model-value="change"
        class="tw-text-xl tw-text-gray-400 tw-font-serif tw-font-semibold tw-self-end"
         />
</template>
